// Where the Filters panel sits. It is `position: fixed`, anchored under its button, so the
// table card's `overflow: hidden` can never clip it however few rows the table has. Its
// height is capped to the space left in the viewport and the panel scrolls inside that cap.

export interface FilterPanelPlacement {
  top: number;
  left: number;
  maxHeight: number;
}

const VIEWPORT_MARGIN = 12;
const GAP_UNDER_BUTTON = 7;
// Room the panel always gets. When the button sits low in the window the panel slides up over it
// rather than shrinking to a sliver (or hanging off the bottom, where a fixed panel cannot be
// scrolled to).
const MINIMUM_PANEL_HEIGHT = 280;

export function filterPanelPlacement(
  buttonRect: { left: number; bottom: number },
  viewportWidth: number,
  viewportHeight: number,
  panelWidth: number,
): FilterPanelPlacement {
  const lowestTop = Math.max(VIEWPORT_MARGIN, viewportHeight - MINIMUM_PANEL_HEIGHT);
  const top = Math.min(buttonRect.bottom + GAP_UNDER_BUTTON, lowestTop);

  // Keep the whole panel inside the viewport horizontally.
  const rightmostLeft = viewportWidth - panelWidth - VIEWPORT_MARGIN;
  const left = Math.max(VIEWPORT_MARGIN, Math.min(buttonRect.left, rightmostLeft));

  // Whatever vertical room is left below the button, scrolling inside it.
  const maxHeight = viewportHeight - top - VIEWPORT_MARGIN;
  return { top, left, maxHeight };
}
